export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_ADMIN_USERS':
      return { ...state, adminUsers: action.adminUsers };
    default:
      return state;
  }
};
